import { render, staticRenderFns } from "./marketplace.vue?vue&type=template&id=0da5f3c3&scoped=true&"
import script from "./marketplace.vue?vue&type=script&lang=js&"
export * from "./marketplace.vue?vue&type=script&lang=js&"
import style0 from "./marketplace.vue?vue&type=style&index=0&id=0da5f3c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da5f3c3",
  null
  
)

export default component.exports